import type { LocaleMessages } from './en';

export const es: LocaleMessages = {
  createYourOwn: {
    SIGN_IN_TO_USE_THIS_TEMPLATE:
      'Inicia sesión o crea una cuenta para personalizar este diseño como propio.',
    CUSTOMIZE_THIS_DESIGN_AS_YOUR_OWN: 'Personaliza este diseño como propio',
    MAKE_YOUR_OWN: 'Personalizar Diseño',
    SIGN_IN_OR_SIGN_UP: 'Iniciar sesión o Registrarse',
  },
  designLocked: {
    DESIGN_LOCKED_TITLE: 'Este diseño se está creando',
    DESIGN_LOCKED_TEXT:
      'Este diseño todavía se está creando. Intenta actualizar en un par de minutos.',
  },
  designPrivate: {
    DESIGN_PRIVATE_TITLE: 'Este diseño es privado',
    DESIGN_PRIVATE_TEXT:
      'La persona que compartió este diseño lo marcó como privado. Inicia sesión o haz público el diseño para verlo.',
  },
  designEmpty: {
    NO_RESULTS_TITLE: 'Este diseño está vacío',
    NO_RESULTS_MESSAGE:
      'La persona que creó este diseño aún no ha agregado nada.',
  },
  design404: {
    TITLE: 'No se puede encontrar el diseño',
    MESSAGE: 'El diseño que buscas no existe o ha sido eliminado.',
  },
  common: {
    LOADING: 'Cargando...',
    ERROR: 'Error',
    SUCCESS: 'Éxito',
    SOMETHING_WENT_WRONG: 'Algo salió mal',
  },
  actionBar: {
    DOWNLOAD: 'Descargar PDF',
    SIGN_OUT: 'Cerrar sesión',
  },
  companySwitcher: {
    SWITCH_COMPANIES: 'Cambiar empresa',
  },
  viewer: {
    PROMPT_TEXT:
      'Pruébalo ahora: Haz clic en un producto para ver más información',
    VIRTUALS_ARE_ILLUSTRATIVE_TEXT:
      'Las maquetas virtuales de productos son solo ilustrativas. La decoración final puede diferir.',
  },
  design: {
    DISCLAIMER:
      'Los precios y disponibilidad de los productos pueden cambiar. Por favor confirma antes de ordenar.',
  },
  productSidebar: {
    PRODUCT_INFO: 'Información del Producto',
    COLORS: 'Muestras de Colores',
    SIZES: 'Tamaños',
    MATERIALS: 'Materiales',
    PRICING: 'Precios',
    MOQ: 'Cantidad mínima de pedido',
    READ_FULL_DESCRIPTION: 'Leer descripción completa',
    DOWNLOAD: 'Descargar',
    NO_IMAGE_AVAILABLE: 'No hay imagen disponible',
    VIEW_ON_OUR_WEBSITE: 'Ver en nuestro sitio web',
  },
  pageSetup: {
    CALL_FOR_PRICING: 'Llama para precios',
    CLICK_FOR_PRICING: 'Clic para precio',
  },
};
